import gql from 'graphql-tag';

export const DESTROY_STOCK_DELIVERY = gql`
	mutation destroyStockDeliveryMutation($id: ID!) {
		destroyStockDelivery(id: $id)
	}
`;
